import { isDirty as isReduxFormDirty } from 'redux-form'

export type AutosaveTarget = 'vehicle' | 'profile' | 'coverage'

const AUTOSAVE_ATTR = 'data-autosave'
const AUTOSAVE_TARGET_ATTR = 'data-autosave-target'

export const getNamedForm = (formName: string) => {
  return document.querySelector(
    `form[name="${formName}"]`
  ) as HTMLFormElement | null
}

export const submitNamedForm = (
  formName: string,
  autosaveTarget?: AutosaveTarget
) => {
  const form = getNamedForm(formName)

  if (!form) return

  if (autosaveTarget) {
    form.setAttribute(AUTOSAVE_ATTR, 'true')
    form.setAttribute(AUTOSAVE_TARGET_ATTR, autosaveTarget)
  }

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit()
    return
  }

  form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
}

export const getAutosaveMetadata = (form: HTMLFormElement | null) => ({
  isAutosave: form?.getAttribute(AUTOSAVE_ATTR) === 'true',
  autosaveTarget:
    (form?.getAttribute(AUTOSAVE_TARGET_ATTR) as AutosaveTarget | null) ||
    null,
})

export const clearAutosaveMetadata = (form: HTMLFormElement | null) => {
  form?.setAttribute(AUTOSAVE_ATTR, 'false')
  form?.setAttribute(AUTOSAVE_TARGET_ATTR, '')
}

export const isNamedFormDirty = (formName: string) => {
  return getNamedForm(formName)?.getAttribute('data-dirty') === 'true'
}

export const hasReduxFormChanges = (state, formName: string) => {
  return (
    isReduxFormDirty(formName)(state) &&
    !!state?.form?.[formName]?.anyTouched
  )
}